import React from 'react'
import { Div, Flex } from '@sendoutcards/quantum-design-ui'
import styles from './GreetingCardCarousel.module.scss'

type CardPreviewType = {
  previewUrl: string
  isHorizontal: boolean
}

type GreetingCardCarouselProps = {
  cards: CardPreviewType[]
  cardWidth?: number
  cardHeight?: number
  gap?: number
}

export const GreetingCardCarousel: React.FC<GreetingCardCarouselProps> = ({
  cards,
  cardWidth = 110,
  cardHeight = 154,
  gap = 12,
}) => {
  const horizontalCardHeight = Math.round(cardHeight * 0.7)
  const horizontalCardWidth = Math.round((horizontalCardHeight * 7) / 5)
  const carouselCards = [...cards, ...cards]

  return (
    <Flex alignItems="center" width="100%">
      <div className={styles.carouselOuter}>
        <div className={styles.carouselInner}>
          {carouselCards.map((card, index) => {
            const isHorizontal = card.isHorizontal
            const width = isHorizontal ? horizontalCardWidth : cardWidth
            const height = isHorizontal ? horizontalCardHeight : cardHeight

            return (
              <Div
                key={`${card.previewUrl}-${index}`}
                style={{
                  width: `${width}px`,
                  height: `${height}px`,
                  flexShrink: 0,
                  borderRadius: 2,
                  overflow: 'hidden',
                  marginRight: index === carouselCards.length - 1 ? 0 : gap,
                }}
              >
                <Div
                  backgroundImage={card.previewUrl}
                  width="100%"
                  height="100%"
                  backgroundPosition="center"
                  backgroundRepeat="no-repeat"
                  backgroundSize="cover"
                />
              </Div>
            )
          })}
        </div>
      </div>
    </Flex>
  )
}
